import { render, staticRenderFns } from "./UsersOfCatalogMobile.vue?vue&type=template&id=2ef8a47f&scoped=true&"
import script from "./UsersOfCatalogMobile.vue?vue&type=script&lang=js&"
export * from "./UsersOfCatalogMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8a47f",
  null
  
)

export default component.exports